import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const uid = () => (window.crypto && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
const stored = (store, key) => {
  try {
    let v = store.getItem(key);
    if (!v) { v = uid(); store.setItem(key, v); }
    return v;
  } catch (e) { return uid(); }
};

export const PageTracker = () => {
  const { pathname, search } = useLocation();
  const { language } = useLanguage();

  useEffect(() => {
    if (pathname.startsWith('/website/admin') || pathname.startsWith('/admin')) return;
    const landing = !sessionStorage.getItem('sm-session');
    const params = new URLSearchParams(search);
    const ev = {
      visitor_id: stored(localStorage, 'sm-visitor'),
      session_id: stored(sessionStorage, 'sm-session'),
      path: pathname,
      landing,
      language,
    };
    if (landing) {
      ev.referrer = document.referrer || null;
      ev.utm_source = params.get('utm_source');
      ev.utm_medium = params.get('utm_medium');
      ev.utm_campaign = params.get('utm_campaign');
    }
    axios.post(`${API}/track`, ev).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
};
